module.exports = __webpack_public_path__ + "static/analytics-3570aed87263899b2aa674abff50976b.jpg";